var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"stepper"},_vm._l((_vm.steps),function(step){return _c('span',{key:step,class:'step step-' + step,on:{"click":function($event){step <= _vm.maxStep ? _vm.setActiveStep(step): null}}},[_vm._v(_vm._s(step))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }